/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cardano API
 * RESTful API for Cardano
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetPoolsByPairParams,
  PairsResponse
} from '../model';

import { arbBotFetcher } from '../../../lib/api/fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetPoolsByPairUrl = (params: GetPoolsByPairParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pairs?${stringifiedParams}` : `/api/pairs`
}

export const getPoolsByPair = async (params: GetPoolsByPairParams, options?: Parameters<typeof arbBotFetcher>[1]): Promise<PairsResponse> => {

  return arbBotFetcher<PairsResponse>(getGetPoolsByPairUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPoolsByPairQueryKey = (params?: GetPoolsByPairParams,) => {
    return [
    `/api/pairs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPoolsByPairQueryOptions = <TData = Awaited<ReturnType<typeof getPoolsByPair>>, TError = void>(params: GetPoolsByPairParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPoolsByPair>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPoolsByPairQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPoolsByPair>>> = ({ signal }) => getPoolsByPair(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPoolsByPair>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPoolsByPairQueryResult = NonNullable<Awaited<ReturnType<typeof getPoolsByPair>>>
export type GetPoolsByPairQueryError = void


export function useGetPoolsByPair<TData = Awaited<ReturnType<typeof getPoolsByPair>>, TError = void>(
 params: GetPoolsByPairParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPoolsByPair>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPoolsByPair>>,
          TError,
          Awaited<ReturnType<typeof getPoolsByPair>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPoolsByPair<TData = Awaited<ReturnType<typeof getPoolsByPair>>, TError = void>(
 params: GetPoolsByPairParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPoolsByPair>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPoolsByPair>>,
          TError,
          Awaited<ReturnType<typeof getPoolsByPair>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPoolsByPair<TData = Awaited<ReturnType<typeof getPoolsByPair>>, TError = void>(
 params: GetPoolsByPairParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPoolsByPair>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPoolsByPair<TData = Awaited<ReturnType<typeof getPoolsByPair>>, TError = void>(
 params: GetPoolsByPairParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPoolsByPair>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPoolsByPairQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






